import React, {Component} from 'react';
import {Empty} from "antd";
/**
 * creat by xcc
 * @description 列表形式
 */
export default class ToggleShowMode extends Component {
    static propTypes = {
    };
    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    render() {
        return (
            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Empty />
            </div>
        )
    }
}